export default __webpack_public_path__ + "static/media/moments-path.f9c4b4fd.gif";